module.exports = __webpack_public_path__ + "media/images/pages/home_featured/who-we-are-mid-2-56c74398c6cdfac828522cd4c2e27960.png";